import type {SelectItem} from '@jetbrains/ring-ui/components/select/select'
import {useEffect, useMemo} from 'react'

import useMatrixParamBuildFieldControl from '../../hooks/useMatrixParamBuildFieldControl'
import type {SelectItemMatrixParameter} from '../../MatrixParamBuild.types'
import {getParameterErrorMessage} from '../../MatrixParamBuild.utils'

function useMatrixParamBuildParameterSelect(
  index: number,
  options: SelectItemMatrixParameter[],
  isDuplicate: boolean,
  value?: string,
) {
  const fieldName = `[${index}].name`
  const {
    setErrorMessageHandler,
    isFieldTouched,
    setHideErrorHandler,
    errorMessage,
    changeParameterHandler,
  } = useMatrixParamBuildFieldControl(fieldName)
  const selectChangeHandler = (selected: SelectItem | null) => {
    const {key = '', label} = selected ?? {}
    const isTypingEvent = typeof key === 'number'
    const name = isTypingEvent ? label?.toString() ?? '' : key
    const parameterErrorMessage = getParameterErrorMessage(isDuplicate, name)

    setErrorMessageHandler(parameterErrorMessage, fieldName, true)
    setHideErrorHandler(fieldName, !name)
    changeParameterHandler(name)
  }
  const selectOptions = useMemo(() => {
    if (!value) {
      return []
    }

    return options.filter(({keyword}) => keyword.some(word => word.startsWith(value)))
  }, [options, value])

  useEffect(() => {
    const parameterErrorMessage = getParameterErrorMessage(isDuplicate, value)

    if (isFieldTouched || isDuplicate) {
      setErrorMessageHandler(parameterErrorMessage, fieldName)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFieldTouched, isDuplicate])

  useEffect(() => {
    setHideErrorHandler(fieldName, !value)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    errorMessage,
    selectOptions,
    selectChangeHandler,
  }
}

export default useMatrixParamBuildParameterSelect
